import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { error } from 'react-notification-system-redux';
import { notificationsConfig } from '../../../../../config/constants';
import { useFarmId } from '../../../InventoryWidget/useFarmId';
import { useDeviationsAPI } from './useDeviationsAPI';
import { WidgetType } from '../../../widget.types';
export const deviationSummaryKeysMap = {
    [WidgetType.DELIVER_DEVIATION]: ['deliveryDeviationsSummary'],
    [WidgetType.LOAD_DEVIATION]: ['loadDeviationsSummary'],
};
export const useDeviationAlertsSummaryQuery = (widgetType) => {
    const dispatch = useDispatch();
    const api = useDeviationsAPI(widgetType);
    const farmId = useFarmId();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        enabled: !!farmId,
        queryFn: () => api.getAlertsSummary(farmId),
        queryKey: deviationSummaryKeysMap[widgetType],
        select: (data) => data
            ? {
                totalCount: data.overWeightCount + data.underWeightCount,
                underWeightCount: data.underWeightCount,
                overWeightCount: data.overWeightCount,
            }
            : { totalCount: 0, overWeightCount: 0, underWeightCount: 0 },
    });
};
//# sourceMappingURL=useDeviationAlertsSummaryQuery.js.map